import { useQuery } from "@tanstack/react-query";

export type DashboardOverview = {
  currentAssessment: {
    id: string | null;
    reportingYear: number;
    status: "none" | "in_progress" | "completed";
    completenessPercent: number;
    organizationName: string | null;
    resumeStep: { tab: string; label: string } | null;
    totalEmissionsTco2e: number | null;
    vsmeLevel: string | null;
    scope1Tco2e: number | null;
    scope2Tco2e: number | null;
    scope3Tco2e: number | null;
    sector: string | null;
    shareLink: { token: string; viewCount: number } | null;
    scopeSummary: {
      operationalScale: {
        totalEmployees: number;
        femaleEmployees: number;
        maleEmployees: number;
        numberOfSites: number | null;
        reportingPeriod: string;
      };
      resourceInventory: {
        energySources: string[];
        waterSources: string[];
        wasteStreams: string[];
      };
      evidenceStats: {
        totalDocuments: number;
        dataCompletenessPercent: number;
      };
    } | null;
  };
  dataAlerts: Array<{
    message: string;
    severity: "warning" | "info";
    workflowTab: string;
  }>;
  assessmentHistory: Array<{
    id: string;
    reportingYear: number;
    organizationName: string;
    completenessPercent: number;
    totalEmissionsTco2e: number;
    vsmeLevel: string;
    locked: boolean;
    status: "draft" | "complete" | "finalized";
    updatedAt: string;
    hasShareLink: boolean;
  }>;
};

export function useDashboardOverview() {
  return useQuery<DashboardOverview>({
    queryKey: ["dashboard-overview"],
    queryFn: async () => {
      const response = await fetch("/api/dashboard/overview", {
        credentials: "include",
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to fetch dashboard overview");
      }
      return response.json();
    },
    staleTime: 1000 * 60,
  });
}
